import React from 'react'
import { useTranslation } from 'react-i18next'
import { SCREEN_WHO_WE_LOOK_FOR, SCREENS } from '../../../../../services/domain/wizardScreens'
import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { WhoWeLookForScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import RequestedGender from './fields/requestedGender/RequestedGender'
import NumberOfRequestedFlatMates from './fields/numberOfRequestedFlatMates/NumberOfRequestedFlatMates'
import AgeOfRequestedFrom from './fields/ageOfRequestedFrom/AgeOfRequestedFrom'
import FlatShareSize from './fields/flatShareSize/FlatShareSize'
import AgeOfRequestedTo from './fields/ageOfRequestedTo/AgeOfRequestedTo'
import NumberOfMaleFlatMates from './fields/numberOfMaleFlatMates/NumberOfMaleFlatMates'
import NumberOfFemaleFlatMates from './fields/numberOfFemaleFlatMates/NumberOfFemaleFlatMates'
import AgeOfFlatMatesFrom from './fields/ageOfFlatMatesFrom/AgeOfFlatMatesFrom'
import AgeOfFlatMatesTo from './fields/ageOfFlatMatesTo/AgeOfFlatMatesTo'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'

const screen = SCREENS[SCREEN_WHO_WE_LOOK_FOR]

const WhoWeLookForScreen: React.FC<InsertionFlowScreensProps<WhoWeLookForScreenValidationResult>> = (props) => {
  const { t } = useTranslation()
  return (
    <ScreenContainer containerId={screen.id} className='' onNavigate={props.onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={'wizard.screen.whoWeLookFor.header'}
        screenName={screen.name}
      >
        <RequestedGender {...props} screenName={screen.name} />
        <NumberOfRequestedFlatMates {...props} screenName={screen.name} />
        <div className='grid grid-flex'>
          <AgeOfRequestedFrom {...props} screenName={screen.name} />
          <AgeOfRequestedTo {...props} screenName={screen.name} />
        </div>
        <div className='margin-top-xl  font-light font-l'>
          {t('wizard.screen.whoWeLookFor.subtitle', 'In this WG live already')}
        </div>
        <FlatShareSize {...props} screenName={screen.name} />
        <div className='grid grid-flex'>
          <NumberOfMaleFlatMates {...props} screenName={screen.name} />
          <NumberOfFemaleFlatMates {...props} screenName={screen.name} />
        </div>
        <div className='grid grid-flex'>
          <AgeOfFlatMatesFrom {...props} screenName={screen.name} />
          <AgeOfFlatMatesTo {...props} screenName={screen.name} />
        </div>
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default WhoWeLookForScreen
